import { ConfirmationModal, Flex, ListItem, Text } from '@modusign/design-system';
import { useState } from 'react';

import { ContentBox } from '@app/features/workspaceManagement';
import pushAdobeDataLayer from '@app/libs/analytics/adobe';
import josa from '@app/libs/josa';

// FIXME: @modusign/design-system에서 ConfirmationModalProps를 제공해주세요
type ConfirmationModalProps = Parameters<typeof ConfirmationModal>[0];

interface BatchPermissionGrantConfirmationModalProps extends ConfirmationModalProps {
  action: '제거' | '변경';
  onConfirm: () => Promise<void>;
  resourceName: '문서' | '템플릿' | '외부문서';
  targetCount: number;
}

function BatchPermissionGrantConfirmationModal({
  action,
  resourceName,
  isOpen,
  targetCount,
  onClose,
  onConfirm,
}: BatchPermissionGrantConfirmationModalProps) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <ConfirmationModal
      confirmButtonLabel="적용"
      isLoading={isLoading}
      isOpen={isOpen}
      title={`일괄 공유 ${action === '제거' ? '제거' : ''} 안내`}
      variant="warning"
      width="xs"
      onClose={onClose}
      onConfirm={async () => {
        setIsLoading(true);
        await onConfirm();
        pushAdobeDataLayer({
          event: 'batchPermissionGrant',
          batchPermissionGrant: {
            action,
            resourceName,
            targetCount,
          },
        });
        setIsLoading(false);
      }}
    >
      <Flex flexDirection="column" gap={7}>
        <Text fontWeight="medium" textAlign="center">
          {targetCount}개 {resourceName}의 공유 설정을 모두 {action}할까요?
        </Text>
        <ContentBox
          backgroundColor="boxBackgroundPrimaryBase"
          borderColor="boxBorderPrimaryBase"
          borderStyle="solid"
          borderWidth="1px"
        >
          <Flex as="ul" flexDirection="column" gap={2}>
            {/* @FIXME: marker color 적용을 용이하도록 수정이 필요합니다 */}
            <ListItem sx={{ '&::marker': { content: '"▪ "', color: 'red' } }}>
              <Text color="textNegativeBase">기존 공유 설정은 초기화됩니다.</Text>
            </ListItem>
            <ListItem sx={{ '&::marker': { content: '"▪ "' } }}>
              권한이 없거나 삭제된 {josa(resourceName, '은/는')} 제외됩니다.
            </ListItem>
          </Flex>
        </ContentBox>
      </Flex>
    </ConfirmationModal>
  );
}

export default BatchPermissionGrantConfirmationModal;
